"use strict";

exports.__esModule = true;
exports.default = void 0;
var _restArguments = _interopRequireDefault(require("./restArguments.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Delays a function for the given number of milliseconds, and then calls
// it with the arguments supplied.
var _default = exports.default = (0, _restArguments.default)(function (func, wait, args) {
  return setTimeout(function () {
    return func.apply(null, args);
  }, wait);
});